import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sparkle, star, ai"><path fillRule="evenodd" clipRule="evenodd" d="M22 12C15.0556 12 12 15.0556 12 22C12 15.0556 8.94444 12 2 12C8.94444 12 12 8.94444 12 2C12 8.94444 15.0556 12 22 12Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSparkle;
